const initialState = {
  filterValue: null,
  containerWidth: 350,
};

const list = (state = initialState, action) => {
  switch (action.type) {
    case 'FUNNEL_FILTER_VALUE_CHANGED':
      return {
        ...state,
        filterValue: action.filterValue,
      };

    case 'SET_FUNNEL_SIDE_LIST_CONTAINER_WIDTH':
      return {
        ...state,
        containerWidth: action.containerWidth,
      };

    default:
      return state;
  }
};

export default list;

export const getFilterValue = (state) => state.filterValue;

export const getSideListContainerWidth = (state) => state.containerWidth;
